import { createAction } from "@reduxjs/toolkit";

import axios from "axios";
import {
  CREATE_ASSET_FROM_STORYBOARD_REQUEST,
  CREATING_ASSET_FROM_STORYBOARD_FAILED,
  CREATING_ASSET_FROM_STORYBOARD_SUCCEEDED,
  FETCH_PAGES_FOR_STORYBOARD_REQUEST,
  FETCH_STORYBOARDS_REQUEST,
  FETCHING_ACTIVATED_WORKSPACES,
  FETCHING_ACTIVATED_WORKSPACES_FAILED,
  FETCHING_ACTIVATED_WORKSPACES_SUCCEEDED,
  FETCHING_PAGES_FOR_STORYBOARD_FAILED,
  FETCHING_PAGES_FOR_STORYBOARD_SUCCEEDED,
  FETCHING_STORYBOARDS_FAILED,
  FETCHING_STORYBOARDS_SUCCEEDED,
  INVALIDATE_CLEVERSTORY_ASSETS,
  INVALIDATE_CLEVERSTORY_WORKSPACES,
} from "./actionTypes";
import {
  CreatingAssetFromPageFailed,
  CreatingAssetFromPageRequest,
  CreatingAssetFromPageSucceeded,
  FetchingActivatedWorkSpacesFailed,
  FetchingActivatedWorkSpacesSucceeded,
  FetchingPagesForStoryboardFailed,
  FetchingPagesForStoryboardSucceeded,
  FetchingStoryboardsFailed,
  FetchingStoryboardsRequest,
  FetchingStoryboardsSucceeded,
  FetchPagesForStoryboardRequest,
} from "src/types/cleverstory";

import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import _ from "lodash";
import buildUrl from "build-url-ts";

// eslint-disable-next-line no-undef
const apiUrl = `${process.env.REACT_APP_API_URL}`;
// eslint-disable-next-line no-undef
const cleverstoryApiUrl = `${process.env.REACT_APP_CLEVERSTORY_API_URL}`;
const API_BASE_URL = `${apiUrl}/api/2.0`;
const ASSETS_BASE_URL = `${API_BASE_URL}/assets`;
const CLEVERSTORY_DATASOURCE_BASE_URL = `${API_BASE_URL}/datasources/cleverstory`;
const CLEVERSTORY_BASE_URL = `${cleverstoryApiUrl}/api/1.0/integrations/cleverstory`;

export const fetchActivatedWorkSpaces = createAction(
  FETCHING_ACTIVATED_WORKSPACES,
);
const fetchingActivatedStoryBoardsSucceeded =
  createAction<FetchingActivatedWorkSpacesSucceeded>(
    FETCHING_ACTIVATED_WORKSPACES_SUCCEEDED,
  );
const fetchingActivatedStoryBoardsFailed =
  createAction<FetchingActivatedWorkSpacesFailed>(
    FETCHING_ACTIVATED_WORKSPACES_FAILED,
  );

const fetchActivatedWorkSpacesSaga = function* (): any {
  const fetchActivatedWorkSpaceApi = () => {
    return axios({
      method: "get",
      url: `${CLEVERSTORY_DATASOURCE_BASE_URL}`,
    }).then((response) => {
      return response.data;
    });
  };
  try {
    const response = yield call(fetchActivatedWorkSpaceApi);
    yield put(fetchingActivatedStoryBoardsSucceeded({ workspaces: response }));
  } catch (error) {
    yield put(fetchingActivatedStoryBoardsFailed({ error }));
  }
};

export const fetchStoryBoardsForWorkSpace = createAction<FetchingStoryboardsRequest>(FETCH_STORYBOARDS_REQUEST);
const fetchingStoryBoardsForWorkSpaceSucceeded = createAction<FetchingStoryboardsSucceeded>(FETCHING_STORYBOARDS_SUCCEEDED);
const fetchingStoryBoardsForWorkSpaceFailed = createAction<FetchingStoryboardsFailed>(FETCHING_STORYBOARDS_FAILED);

const fetchStoryBoardsForWorkSpaceSaga = function* (
  action: ReturnType<typeof fetchStoryBoardsForWorkSpace>,
): any {
  const { workspace } = action.payload;
  const url = buildUrl(`${CLEVERSTORY_BASE_URL}/${workspace}/storyboard`, {
    queryParams: {
      query: _.get(action.payload, "query", ""),
      page: _.get(action.payload, "page", 0),
      limit: _.get(action.payload, "limit", 10),
    },
  });
  const fetchStoryBoardsForWorkSpaceApi = () => {
    return axios({
      method: "get",
      url,
    }).then((response) => {
      return response.data;
    });
  };
  try {
    const response = yield call(fetchStoryBoardsForWorkSpaceApi);
    yield put(
      fetchingStoryBoardsForWorkSpaceSucceeded({ response, workspace }),
    );
  } catch (error) {
    yield put(fetchingStoryBoardsForWorkSpaceFailed({ workspace, error }));
  }
};

export const fetchPagesForStoryBoardRequest = createAction<FetchPagesForStoryboardRequest>(FETCH_PAGES_FOR_STORYBOARD_REQUEST);
const fetchingPagesForStoryBoardSucceeded = createAction<FetchingPagesForStoryboardSucceeded>(FETCHING_PAGES_FOR_STORYBOARD_SUCCEEDED);
const fetchingPagesForStoryBoardFailed = createAction<FetchingPagesForStoryboardFailed>(FETCHING_PAGES_FOR_STORYBOARD_FAILED);

export const fetchPagesForStoryBoardSaga = function* (
  action: ReturnType<typeof fetchPagesForStoryBoardRequest>,
): any {
  const { workspace, storyboard } = action.payload;
  const url = buildUrl(CLEVERSTORY_BASE_URL, {
    path: `${storyboard}/pages`,
    queryParams: {
      page: _.get(action.payload, "page", 0),
      limit: _.get(action.payload, "limit", 20),
    },
  });
  const fetchPagesForStoryBoardApi = () => {
    return axios({
      method: "get",
      url,
    }).then((response) => response.data);
  };
  try {
    const response = yield call(fetchPagesForStoryBoardApi);
    yield put(fetchingPagesForStoryBoardSucceeded({ response, workspace, storyboard }));
  } catch (error) {
    yield put(fetchingPagesForStoryBoardFailed({ workspace, storyboard, error }));
  }
};

export const createAssetFromStoryBoard = createAction<CreatingAssetFromPageRequest>(CREATE_ASSET_FROM_STORYBOARD_REQUEST);
const creatingAssetFromStoryBoardSucceeded = createAction<CreatingAssetFromPageSucceeded>(CREATING_ASSET_FROM_STORYBOARD_SUCCEEDED);
const creatingAssetFromStoryBoardFailed = createAction<CreatingAssetFromPageFailed>(CREATING_ASSET_FROM_STORYBOARD_FAILED);

export const createAssetFromStoryBoardSaga = function* (
  action: ReturnType<typeof createAssetFromStoryBoard>,
): any {
  const { workspace, storyboard, page } = action.payload;

  const url = buildUrl(ASSETS_BASE_URL, {
    path: `cleverstory_page`,
  });

  const createPageFromStoryBoardApi = () => {
    return axios({
      method: "POST",
      url: url,
      data: {
        type: "cleverstory_page",
        workspace: workspace,
        storyboard: storyboard,
        page: page.id,
        name: page.name,
      },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(createPageFromStoryBoardApi);
    yield put(
      creatingAssetFromStoryBoardSucceeded({
        workspace,
        storyboard,
        pageId: page.id,
        asset: response,
      }),
    );
  } catch (error) {
    yield put(creatingAssetFromStoryBoardFailed({ 
      workspace, 
      storyboard, 
      pageId: page.id, 
      error 
    }));
  }
};

export const invalidateCleverstoryAssets = createAction<string>(INVALIDATE_CLEVERSTORY_ASSETS);

export const invalidateCleverstoryWorkspaces = createAction<void>(INVALIDATE_CLEVERSTORY_WORKSPACES);

export default function* cleverStorySaga() {
  yield takeEvery(FETCHING_ACTIVATED_WORKSPACES, fetchActivatedWorkSpacesSaga);
  yield takeEvery(FETCH_STORYBOARDS_REQUEST, fetchStoryBoardsForWorkSpaceSaga);
  yield takeEvery(FETCH_PAGES_FOR_STORYBOARD_REQUEST, fetchPagesForStoryBoardSaga);
  yield takeEvery(CREATE_ASSET_FROM_STORYBOARD_REQUEST, createAssetFromStoryBoardSaga);
}
